var render = function render(){var _vm=this,_c=_vm._self._c;return _c('doughnut-chart',{attrs:{"styles":{ position: 'relative', zIndex: '1' },"chartData":_vm.chartData,"chartOptions":_vm.chartOptions,"width":_vm.$vuetify.breakpoint.mdAndDown ? 95 : 120,"height":_vm.$vuetify.breakpoint.mdAndDown ? 95 : 120}})
}
var staticRenderFns = []

export { render, staticRenderFns }